import React from 'react';

import { removeTrailingZeros } from '@cryptoboyio/mercuryo-lab/utils';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

import style from './Value.scss';

const cn = bemCssModules(style, 'Value');
const ti = getTestId('Value');

export type TValue = {
  currency: CryptoCurrencyEnum;
};

export const Value: CustomFC<TValue> = ({ className, currency }) => {
  const [{ wallet }] = useStore();

  const balance = wallet.data?.[currency]?.balance || '0';

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {removeTrailingZeros(balance)} {currency}
    </div>
  );
};

export default Value;
